import { Injectable } from '@angular/core';

@Injectable()
export class LoginService {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/core/login.service.ts